import { render, staticRenderFns } from "./yingxiang-detail.vue?vue&type=template&id=411baeee&scoped=true&"
import script from "./yingxiang-detail.vue?vue&type=script&lang=ts&"
export * from "./yingxiang-detail.vue?vue&type=script&lang=ts&"
import style0 from "./yingxiang-detail.vue?vue&type=style&index=0&id=411baeee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411baeee",
  null
  
)

export default component.exports